
export const ERROR_TYPE = {
  EXIST_EMAIL: 0,
  EXIST_NICKNAME: 1,
  NOT_EXIST_USER: 2,
  INCORRECT_PASSWORD: 3,
  EXIST_PHONE: 4,
  INCORRECT_PHONE_CODE: 5,
  NOT_FOUND: 6,
  INCORRECT_ANSWER: 7,
  SUBSCRIBING: 8,
  NOT_SIGNUP_EMAIL: 9,
  FAILED_MISSION: 10,
  SUCCESSFUL_MISSION: 11,
  NOT_STARTED_MISSION: 12,
  INCORRECT_LOCATION: 13,
  EXIST_USER: 14,
  ALREADY_START_SUBSCRIPTION: 15,
  FAIL_GET_PORTONE_TOKEN: 16,
  FAIL_CANCEL_PAYMENT: 17,
  NO_SUBSCRIBING: 18,
  NOT_EXIST_PAYMENT: 19,
  NOT_FOUND_PRODUCT: 20,
  FAIL_PAYMENT: 21, //결제 실패
  NOT_FOUND_PAYMENT_HISTORY: 22, //결제내역 없음.
  NOT_FOUND_SUBSCRIPTION: 23, //구독 정보 없음.
  NOT_FOUND_FAIL_PAYMENT: 24, //구독 결제 실패내역 없음
  NOT_EXIST_COUPON: 25,
  ALREADY_REGISTER_COUPON: 26, //등록되었거나 사용만료된 쿠폰
}

export const PAYMENT_STATUS = {
  PENDING: 0,
  SUCCESS: 1,
  CANCEL: 2,
  CANCEL_PENDING: 3,
  FAILED: 4,
}

export type Product = {
  id: number,
  name: string,
  price: number,
  vat: number
}
export const Products: Product[] = [
  { id: 0, name: '정기자문료', price: 100000, vat: 10000 },
  { id: 1, name: '환불', price: 0, vat: 0 },
  { id: 2, name: '정기자문료', price: 50000, vat: 5000},
  { id: 3, name: '특별자문료', price: 900000, vat: 90000 },
  { id: 4, name: '경찰 조사용 의견서', price: 50000, vat: 5000 },
  { id: 5, name: '승소사례', price: 50000, vat: 5000 },
  { id: 6, name: '형사재판 의견서', price: 50000, vat: 5000 },
  { id: 7, name: '민사재판 의견서', price: 50000, vat: 5000 },
  { id: 8, name: '경찰 조사 시뮬레이션', price: 400000, vat: 40000 },
  { id: 9, name: '기타', price: 0, vat: 0 },
  { id: 10, name: '', price: 0, vat: 0 },
  { id: 11, name: '', price: 0, vat: 0 },
  { id: 12, name: '', price: 0, vat: 0 },
  { id: 13, name: '', price: 0, vat: 0 },
  { id: 4, name: '', price: 0, vat: 0 },
]

export const AdditionalPaymentType = {
  EXTENSION_SUBSCRIPTION: 0,
  ETC: 1,
}